import { Box, Typography, Grid, Paper, styled, Divider } from '@mui/material';
import React from 'react';
import { useLocation } from 'react-router-dom';
import Footer from './Footer';
import Nav from './Nav';

const StyledImage = styled('img')(({ theme }) => ({
  width: '70%',
  height: 'auto',
  borderRadius: '8px',
  boxShadow: '0px 4px 4px 4px #00000040',
}));

const StoryText = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(2),
  lineHeight: 1.8,
}));

export const SuccessStoryDetail = () => {
  const location = useLocation();
  const { image, bride, groom, story, date } = location.state;
  console.log(date);

  return (
    <Box>
      <Nav />
      <Box mt={12} mb={5} px={2}>
        <Grid container spacing={4} alignItems="center" justifyContent="center">
          <Grid item xs={12} md={10}>
            <Typography variant="h4" align="center" fontWeight="bold" gutterBottom>
              {bride} & {groom} - A Perfect Match!
            </Typography>
            {date && (
              <Typography
                variant="subtitle1"
                align="center"
                color="text.secondary"
                gutterBottom
              >
                {new Date(date).toLocaleDateString('en-GB', {
                  day: 'numeric',
                  month: 'long',
                  year: 'numeric',
                })}
              </Typography>
            )}

          </Grid>
          <Grid item xs={12} md={5}>
            <StyledImage src={image} alt={`${bride} weds ${groom}`} />
          </Grid>

          <Divider orientation="vertical" flexItem sx={{ mx: 2, borderColor: "black" }} />

          <Grid item xs={12} md={5}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Read how {bride} and {groom} found each other on IND Matrimony
            </Typography>
            <StoryText variant="body1">{story}</StoryText>

          </Grid>
        </Grid>
      </Box>
      <Footer />
    </Box>
  );
};
